import { actionCreator } from '@ardoq/rxbeach';
import { ImportAPIPayloadExamplesResponse } from '@ardoq/api-types/integrations';
import { ErrorDetails, TabType } from './types';
import { ArdoqId } from '@ardoq/api-types';

export const fetchImportApiPayloadExamples = actionCreator<ArdoqId>(
  '[importApiPayloadDrawer] fetch import api payload examples'
);

export const processImportApiPayloadExamplesResponse =
  actionCreator<ImportAPIPayloadExamplesResponse>(
    '[importApiPayloadDrawer] process import api payload examples response'
  );

export const processImportApiPayloadExamplesError = actionCreator<ErrorDetails>(
  '[importApiPayloadDrawer] process import api payload examples error'
);

export const changeActiveTab = actionCreator<TabType>(
  '[importApiPayloadDrawer] change active tab'
);

export const setCopiedTab = actionCreator<TabType | null>(
  '[importApiPayloadDrawer] set copied tab'
);

export const toggleShowDetails = actionCreator(
  '[importApiPayloadDrawer] toggle show details'
);

export const copyToClipboard = actionCreator<TabType>(
  '[importApiPayloadDrawer] copy to clipboard'
);
